import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "subaccount-select__label" }
const _hoisted_2 = {
  key: 0,
  class: "subaccount-select__item"
}
const _hoisted_3 = { class: "truncate-text" }
const _hoisted_4 = {
  key: 0,
  class: "subaccount-select__item-right"
}
const _hoisted_5 = {
  key: 1,
  class: "subaccount-select-selected__placeholder"
}
const _hoisted_6 = { class: "truncate-text" }
const _hoisted_7 = {
  key: 0,
  class: "subaccount-select__item-right"
}

import { inject, ref, type PropType } from 'vue';

import BigNumber from '@exchange/helpers/bignumber';
import { type ModalVariant } from '@exchange/libs/modals/src';
import { type SubaccountType } from '@exchange/libs/trading-accounts/service/src';
import { LockedFunds } from '@exchange/libs/transactions/shared/src';
import { type CurrencyModel } from '@exchange/libs/utils/currency/src';

export interface SubaccountOption {
  displayValue: string;
  displayRight: string;
  displayRightSymbol: string;
  type: SubaccountType;
  name: string;
  accountId: string;
  correspondingBalance: {
    available: BigNumber;
    locked: BigNumber;
    precision: number;
  };
  disabled: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SubaccountSelect',
  props: {
  currency: { type: Object as PropType<CurrencyModel>, required: true },
  disabled: { type: Boolean, default: false },
  label: { type: String, required: true },
  lockedFunds: { type: String, required: false },
  name: { type: String, required: true },
  options: { type: Array as PropType<Array<SubaccountOption>>, required: true },
  placeholder: { type: String, default: '' },
  precision: { type: Number, required: true },
  selectable: { type: Function, required: false },
  value: { type: [Object, String], default: () => null },
  variant: { type: String as PropType<ModalVariant>, required: true },
},
  emits: ["update:value"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

const balanceMasked = inject('balanceMasked', ref(false));

const onItemClick = (value: SubaccountOption) => emit('update:value', value);

return (_ctx: any,_cache: any) => {
  const _component_ot_balance = _resolveComponent("ot-balance")!
  const _component_ot_select = _resolveComponent("ot-select")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["subaccount-select", { 'subaccount-select--disabled': __props.disabled }])
  }, [
    _createElementVNode("label", _hoisted_1, _toDisplayString(__props.label), 1),
    _createVNode(_component_ot_select, {
      class: "subaccount-select__input",
      label: "displayValue",
      variant: __props.variant === 'dark' ? 'dark-outlined' : 'light-outlined',
      "menu-top-space": true,
      options: __props.options,
      disabled: __props.disabled,
      value: __props.value,
      selectable: __props.selectable,
      "onUpdate:value": onItemClick
    }, {
      "selected-option": _withCtx((selected) => [
        selected
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(selected.displayValue), 1),
              (selected.displayRight)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_ot_balance, {
                      masked: _unref(balanceMasked),
                      precision: selected.correspondingBalance.precision,
                      symbol: selected.displayRightSymbol,
                      value: selected.displayRight
                    }, null, 8, ["masked", "precision", "symbol", "value"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(__props.placeholder), 1))
      ]),
      option: _withCtx((option) => [
        _createElementVNode("div", {
          class: _normalizeClass(["subaccount-select__item subaccount-select__list-option", { 'subaccount-select__item--disabled': option.disabled }])
        }, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(option.displayValue), 1),
          (option.displayRight)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_ot_balance, {
                  masked: _unref(balanceMasked),
                  precision: option.correspondingBalance.precision,
                  symbol: option.displayRightSymbol,
                  value: option.displayRight
                }, null, 8, ["masked", "precision", "symbol", "value"])
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _: 1
    }, 8, ["variant", "options", "disabled", "value", "selectable"]),
    (__props.lockedFunds)
      ? (_openBlock(), _createBlock(_unref(LockedFunds), {
          key: 0,
          class: "subaccount-select__sub-text",
          currency: __props.currency.symbol,
          masked: _unref(balanceMasked),
          precision: __props.precision,
          value: __props.lockedFunds,
          variant: __props.variant
        }, null, 8, ["currency", "masked", "precision", "value", "variant"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})